<template>
  <layout>
    <div id="candidate-page">
      <!-- Header -->
      <header
        id="home"
        class="header text-white h-fullscreen text-center text-lg-left"
      >
        <div class="container index-up">
          <div class="row align-items-center h-100">
            <div class="col-lg-6 ml-auto">
              <lazy-image
                :src='require("../assets/landings/illustration/illustration-for-candidate.svg")'
                :img-class="['mx-auto', 'd-block', 'w-80', 'animated', 'fadeInLeft', 'delay-1s', 'slow', 'img-header']"
                placeholder="url of placeholder or loading image"
              />
            </div>

            <div class="col-12 col-lg-6 animated fadeInRight delay-1s slow">
              <h1 class="title-header font-weight-bold">
                A vaga de emprego que você procura <strong v-if="userIsLoggedIn">, {{ currentUser.name }}</strong>
              </h1>
              <p class="lead mt-5 safari_only">
                Ao cadastrar seu currículo, ele será recomendado para processos seletivos que melhor se enquadram no seu   perfil.
              </p>

              <p
                v-if="!userIsLoggedIn"
                class="gap-xy"
              >
                <a
                  class="btn btn-lg btn-round btn-success mw-200 m-0 mt-4"
                  href="/sign-up"
                >
                  CADASTRE-SE GRATUITAMENTE
                </a>
              </p>
            </div>
          </div>

          <div class="partner partner-sm safari_only_se">
            <search-bar class="animated fadeInUp delay-1s slow" />
          </div>
        </div>
      </header><!-- /.header -->

      <!-- Main Content -->
      <main class="main-content">
        <!--
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        | List Vacancy
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        !-->
        <section
          id="ultimas-vagas"
          class="section py-8"
        >
          <list-vacancy />
        </section>

        <!--
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        | Step by step
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        !-->
        <section
          id="como-funciona"
          class="section py-5"
        >
          <div class="container">
            <header class="section-header">
              <h2 class="text-color-fifth">
                Como funciona para candidatos
              </h2>
            </header>


            <div class="row align-items-center">
              <div class="col-md-6">
                <div
                  id="tab-1"
                  class="tab-pane fade show active"
                >
                  <img
                    src="../assets/landings/gifs/steps.gif"
                    class="shadow-3"
                    alt="..."
                  >
                </div>
              </div>

              <div class="col-md-6">
                <ul class="step nav nav-tabs-shadow nav-tabs-border">
                  <li class="step-item nav-item">
                    <div class="step-icon">
                      <span class="iconbox">1</span>
                    </div>

                    <div class="step-content">
                      <h6><strong>Cadastre seu currículo</strong></h6>
                      <p>Preencha todas as suas informações pessoais e profissionais do seu CV em nosso sistema fácil e intuitivo.</p>
                    </div>
                  </li>

                  <li class="step-item nav-item">
                    <div class="step-icon">
                      <span class="iconbox">2</span>
                    </div>

                    <div class="step-content">
                      <h6><strong>Responda o questionário de valores</strong></h6>
                      <p>Guie seu CV para a vaga e empresa que se adequa ao seu perfil.</p>
                    </div>
                  </li>

                  <li class="step-item nav-item">
                    <div class="step-icon">
                      <span class="iconbox">3</span>
                    </div>

                    <div class="step-content">
                      <h6><strong>Candidate-se às vagas</strong></h6>
                      <p>Veja as oportunidades que são mais aderentes à você e esteja mais próximo do seu novo emprego.</p>
                    </div>
                  </li>

                  <li class="step-item nav-item">
                    <div class="step-icon">
                      <span class="iconbox">4</span>
                    </div>

                    <div class="step-content">
                      <h6><strong>Seja contratado</strong></h6>
                      <p>Seu currículo será avaliado por nossos clientes que entrarão em contato com você. Tenha retorno e feedbacks sempre que se candidatar.</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <!--
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        | FAQ
        |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
        !-->
        <section
          id="faq"
          class="section"
        >
          <div class="container">
            <header class="section-header">
              <small>FAQ</small>
              <h2 class="text-color-fifth">
                Perguntas frequentes
              </h2>
              <p>Tire suas dúvidas abaixo e caso tenha alguma outra pergunta entre em contato.</p>
            </header>


            <div class="row gap-y">
              <div class="col-md-6 col-xl-4">
                <h5>Para que o Abler utiliza meus dados do currículo?</h5>
                <p>As empresas buscam o candidato ideal, e seus dados vão convencer sobre quem recrutar. Suas informações serão usadas por nós para garantir que seu perfil seja visualizado pela empresa que se interessa por suas qualidades e experiências.</p>
              </div>


              <div class="col-md-6 col-xl-4">
                <h5>Tenho que pagar para me cadastrar ou se candidatar?</h5>
                <p>Nosso sistema é gratuito, você pode cadastrar seu cv sem custo e buscar vagas de emprego.</p>
              </div>


              <div class="col-md-6 col-xl-4">
                <h5>Posso enviar meu currículo por email?</h5>
                <p>O processo de recrutamento e seleção é feito pela plataforma de duas maneiras, você pode se cadastrar a vagas de emprego após preencher completamente seu perfil, e as empresas podem buscar um candidato para uma vaga e ter acesso ao seu perfil.</p>
              </div>


              <div class="col-md-6 col-xl-4">
                <h5>Como funciona os processos seletivos?</h5>
                <p>Você recebe um convite para dar continuidade no processo seletivo através da plataforma, caso confirme, a empresa entrará em contato para as próximas etapas.</p>
              </div>


              <div class="col-md-6 col-xl-4">
                <h5>Porque não consigo me candidatar?</h5>
                <p>É possível que seu currículo esteja incompleto, verifique se todas as informações foram preenchidas corretamente, caso sim, seu cv pode não estar de acordo com as exigências da vaga.</p>
              </div>


              <div class="col-md-6 col-xl-4">
                <h5>Vocês fazem análise do meu currículo e aconselhamento profissional?</h5>
                <p>Nosso sistema é gratuito para cadastro de currículo e candidaturas em vagas de emprego, seu cv é analisado pela plataforma para conferência de informações necessárias para o cadastro, não prestamos consultoria profissional.</p>
              </div>
            </div>
          </div>
        </section>
      </main><!-- /.main-content -->
    </div>
  </layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import mixins from '../mixins/mixins';

import Layout from './shared/layout.vue';
import SearchBar from '../components/search-bar.vue';
import ListVacancy from '../components/list-vacancy.vue';

export default {
  name: 'CandidatePage',
  components: {
    Layout,
    SearchBar,
    ListVacancy,
  },
  mixins: [mixins],
  props: {
    currentUserProp: {
      type: Object,
      required: true,
    },
    currentUserTypeProp: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('UserStore', [
      'currentUser',
    ]),
    ...mapGetters('UserStore', [
      'currentUserIsAdmin',
      'currentUserIsCompanyUser',
      'userIsLoggedIn',
    ]),
  },
  mounted() {
    const currentUser = { ...this.currentUserProp };
    const currentUserType = this.currentUserTypeProp;

    this.$store.commit('UserStore/SET_CURRENT_USER', currentUser);
    this.$store.commit('UserStore/SET_CURRENT_USER_TYPE', currentUserType);
  },
};
</script>

<style lang="scss" scoped>
  @use '../assets/stylesheet/variables.scss' as *;
  #candidate-page {
    header.header {
      background-color: $abler_primary;

      .title-header {
        font-size: 2.4rem;
        line-height: 1.4;

        @media screen and (max-width: 576px) {
          font-size: 1.8rem;
          line-height: 1.4;
        }
      }

      .title-header + p.lead {
        @media screen and (max-width: 576px) {
          font-size: 1.07rem;
        }
      }

      .img-header {
        @media screen and (max-width: 576px) {
          width: 70% !important;
          margin-top: 4rem !important;
        }
      }

      #search-bar {
        @media screen and (max-width: 576px) {
          position: absolute;
          bottom: -15rem;
          // bottom: -39%;
        }
      }

      .btn.btn-success {
        background-color: $abler_secondary;
        outline: none;
        border: 0;

        &:hover {
          box-shadow: none;
        }
      }

      .display-4 {
        font-size: 2.6rem;
      }
    }

    main.main-content {
      @media screen and (max-width: 576px) {
        padding-top: 6rem !important;
      }
      .card {
        &:hover {
          transform: scale(1.03);
        }
      }

      header.section-header {
        @media screen and (max-width: 576px) {
          margin: 5px auto 37px;
        }
      }

      .step {
        .step-item:last-child {
          // height: 0rem;

          div.step-content > h6 > strong {
            color: #3cd458 !important;
          }

          .iconbox {
            background-color: #3cd458;
            color: #fff;
          }
        }

        &.nav-tabs-shadow .nav-link.active,
        &.nav-tabs-shadow .nav-item.show .nav-link {
          padding-top: 1rem !important;
        }

        @media screen and (max-width: 767px) {
          padding-left: 0;
          margin-top: 2rem;
        }
      }
    }
  }

  .index-up {
    z-index: 1 !important;
  }

  // Mobile Safarai - Iphones
  @media screen and (max-width: 576px) {
    _::-webkit-full-page-media, _:future, :root .safari_only {
      display: none;
    }
    _::-webkit-full-page-media, _:future, :root .safari_only_se {
      padding-top: 35px;
    }
  }
</style>
